<template>
    <div class="ratings">
        <div class="flex flex-row">
            <div id="highlighted_review" v-if="formattedReviews && formattedReviews[0]" class="ratings-first-item desktop-hidden">
                <StarRating :rating="formattedReviews[0].rating" class="ratings-container-item-img"/>
                <p class="ratings-first-item-comment">{{ formattedReviews[0].review }}</p>
                <div class="ratings-container-item-author">
                    <p class="ratings-container-item-author-name title-s">{{ formattedReviews[0].user_name }}</p>
                    <p class="ratings-container-item-author-date">{{formattedReviews[0].created_date}}</p>
                </div>
            </div>
            <div class="ratings-header">
                <span class="headline-l" id="reviews_header_text">Ratings & Reviews</span>
                <a href="#" class="primary" @click="openReview()">Write a Review</a>
            </div>
            <div class="ratings-container">
                <div v-for="(review, i) in reviewsToShow" :key="i" :class="{'ratings-container-item': true}">
                    <StarRating :rating="review.rating" class="ratings-container-item-img"/>
                    <p :class="'ratings-container-item-comment'">{{ review.review }}</p>
                    <div class="ratings-container-item-author">
                        <p class="ratings-container-item-author-name title-s">{{ review.user_name }}</p>
                        <p class="ratings-container-item-author-date">{{ review.created_date }}</p>
                    </div>
                </div>
                <a v-if="reviews.length > 5" href="javascript:void(0)" class="ratings-container-show-more mobile-hidden" @click="toggleShowMore()">
                    Show {{ showingMore ? "Less" : "More" }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import moment from "moment";
    import { ref, computed } from "vue";
    import ReviewModal from "@/components/ReviewModal.vue";
    import StarRating from "@/components/StarRating.vue"
    import { useDialog } from "primevue/usedialog";
    

    let props = defineProps({
        reviews: {
            type: Array,
            required: true,
            default(){
                return []
            }
        },
        itemId: {
            type: Number,
            required: true
        }
    })


    let formattedReviews = computed(()=>{
        return props.reviews.map((review)=>{
            return {
                ...review,
                created_date: formatDate(review.created_date)
            }
        })
    })
    function formatDate(dateStr){
        return dateStr ? moment(dateStr).format("MM/DD/YY") : "";
    };

    const reviewsToShow = computed(()=>{
        return showingMore.value ? formattedReviews : formattedReviews.value.slice(0,5)
    })

    let showingMore = ref(false);
    function toggleShowMore() {
        showingMore.value = !showingMore.value;
        document.getElementById("reviews_header_text")?.scrollIntoView({
            behavior: "smooth",
            block: showingMore.value ? "start" : "center"
        });
    }

    let dialog = useDialog();
    let openReview = () => {
        dialog.open(ReviewModal, {
            props: {
                showHeader: false,
                modal: true
            },
            data: {
                itemId: props.itemId,
                isModal: true,
            },
        });
    };
</script>
